// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zHBE","title":"styles_title__b5VXB"};